<script>
import { mapActions, mapState } from 'vuex';
import toggleModal from '@/mixins/toggleModal';
import notificationWithIcon from '@/utils/notification';

export default {
  data() {
    return {
      firstSteps: [],
      secondSteps: [],
      thirdsSteps: [],
      dependProducts: [],
      linkParameters: {},
    };
  },
  props: {
    productName: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      getWizardStepsAction: 'wizards/getWizardSteps',
    }),
    changeSecondStep(value) {
      const anotherSecondStepItems = JSON.parse(JSON.stringify(
        this.wizardSteps
          .find((item) => item.designVersion === 1)
          .orderSections
          .filter((itm) => itm.productId !== value.productId),
      ));
      anotherSecondStepItems.forEach((item) => {
        if (Object.keys(this.linkParameters).includes(item.productId.toString())) {
          this.linkParameters[item.productId] = false;
        }
      });
    },
    changeThirdStep(value) {
      const foreverProducts = JSON.parse(JSON.stringify(
        this.products
          .filter((product) => product.name === 'cloud_download' || product.daysSubscribe === 365),
      ));
      const idsForeverProducts = foreverProducts.map((product) => product.id);
      if (idsForeverProducts.includes(value.productId)) {
        const anotherForeverProduct = foreverProducts
          .find((product) => product.id !== value.productId);
        this.linkParameters[anotherForeverProduct.id] = false;
      }
    },
    copyLinkToClipboard() {
      const queryParameters = Object.entries(this.linkParameters).map(([key, value]) => (
        value ? `${key}=${value}&` : null
      )).join('');
      navigator.clipboard.writeText(`https://foreverstudios.com/digitize-editor/?${queryParameters}typeProduct=${this.productName}`)
        .then(() => {
          notificationWithIcon('success', 'Link copied!');
        })
        .catch(() => {
          notificationWithIcon('error', 'Error copying link');
        });
    },
  },
  mounted() {
    this.getWizardStepsAction(this.productName);
  },
  computed: {
    ...mapState({
      wizardSteps: (state) => state.wizards.wizardSteps,
    }),
  },
  watch: {
    wizardSteps: {
      handler(newValue) {
        this.firstSteps = newValue.find((item) => item.designVersion === 0).orderSections;
        this.secondSteps = newValue.find((item) => item.designVersion === 1).orderSections;
        this.thirdsSteps = newValue.find((item) => item.designVersion === 2).orderSections;
      },
      deep: true,
    },
  },
};
</script>

<template>
  <div>
    <a-modal :open="show" :footer="null" @cancel="hideModal">
      <h1 class="text-2xl font-bold mb-2">Create digitize link</h1>
      <div style="margin-bottom: 30px">
        <h2 class="text-1.5xl font-semibold mb-2">Step 1</h2>
        <div
          v-for="firstStep in firstSteps"
          v-bind:key="firstStep.productId"
        >
          <h4 class="text-1xl font-semibold mb-2">{{firstStep.title}}</h4>
          <a-switch
            checked-children="On"
            un-checked-children="Off"
            v-model:checked="linkParameters[firstStep.productId]"
            v-if="
              products.find((product) => product.id === firstStep.productId)
              ?.dependQuantityProductIds.length
            "
          />
          <a-input
            type="number"
            v-model:value="linkParameters[firstStep.productId]"
            validation="min:0"
            style="max-width: 300px"
            v-else
          />
        </div>
      </div>
      <div style="margin-bottom: 30px">
        <h2 class="text-1.5xl font-semibold mb-2">Step 2</h2>
        <div
          v-for="secondStep in secondSteps"
          v-bind:key="secondStep.productId"
        >
          <h4 class="text-1xl font-semibold mb-2">{{secondStep.title}}</h4>
          <a-switch
            checked-children="On"
            un-checked-children="Off"
            v-model:checked="linkParameters[secondStep.productId]"
            @change="changeSecondStep(secondStep)"
          />
        </div>
      </div>
      <div style="margin-bottom: 30px">
        <h2 class="text-1.5xl font-semibold mb-2">Step 3</h2>
        <div
          v-for="thirdStep in thirdsSteps"
          v-bind:key="thirdStep.productId"
        >
          <h4 class="text-1xl font-semibold mb-2">{{thirdStep.title}}</h4>
          <a-switch
            checked-children="On"
            un-checked-children="Off"
            v-model:checked="linkParameters[thirdStep.productId]"
            @change="changeThirdStep(thirdStep)"
            v-if="products.find((product) => product.id === thirdStep.productId)
              ?.dependQuantityProductIds.length
              || products.find((product) => product.id === thirdStep.productId)
              ?.daysSubscribe === 365"
          />
          <a-input
            type="number"
            v-model:value="linkParameters[thirdStep.productId]"
            validation="min:0"
            style="max-width: 300px"
            v-else
          />
        </div>
      </div>
      <a-button
        type="primary"
        @click="() => {
          copyLinkToClipboard();
        }"
      >
        Get link
      </a-button>
    </a-modal>
  </div>
</template>

<style scoped lang="scss">

</style>
